/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from 'react';
import { Transition, Popover } from '@headlessui/react';
import { Backdrop } from '../Backdrop';

export interface FlyoutPopoverProps {
  children: JSX.Element;
  button: JSX.Element;
  handleClose: Function;
}

export const FlyoutPopover = ({
  children,
  button,
  handleClose,
  bgColor,
}: FlyoutPopoverProps) => (
  <Popover
    as='nav'
    className='h-full'>
    <Popover.Button as={Fragment}>{button}</Popover.Button>
    <Backdrop
      bgColor={`bg-${bgColor ? bgColor.classname : 'white'}`}
      onClick={handleClose}
    />
    <Transition
      as={Fragment}
      enter='transition ease-out duration-700'
      enterFrom='opacity-0 -translate-y-3'
      enterTo='opacity-100 translate-y-0'
      leave='transition ease-in duration-200'
      leaveFrom='opacity-100 translate-y-0'
      leaveTo='opacity-0 -translate-y-3'>
      <div
        className={`absolute z-40 bg-${
          bgColor ? `${bgColor.classname} text-white` : 'white'
        } inset-x-0 top-16 transform `}>
        <Popover.Panel>
          {({ close }) => <div onClick={() => close()}>{children}</div>}
        </Popover.Panel>
      </div>
    </Transition>
  </Popover>
);
